<div
  [title]="!isOpen() ? (sectionLabelKey() | translate) : ''"
  (click)="toggleSection.emit()"
  class="sidebar-section-header"
>
  <i [class]="'pi ' + sectionIcon()"></i>
  @if (isOpen()) {
  <span class="sidebar-section-label">{{ sectionLabelKey() | translate }}</span>
  <i
    [class.rotated]="expanded()"
    class="pi pi-chevron-down sidebar-chevron"
  ></i>
  }
</div>
@if (expanded() || !isOpen()) { @for (item of items(); track item.labelKey) {
<app-sidebar-nav-btn
  [labelKey]="item.labelKey"
  [icon]="item.icon"
  [path]="item.path"
  [isOpen]="isOpen()"
  [active]="isItemActive(item.path)"
  (navClicked)="navClicked.emit($any($event))"
/>
} }
